/* Important Info component on the BreakdownAddEditForm
   telling users where to add new locations */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const Info = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
        <div className={`px-3 py-2 mt-2 ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>IMPORTANT</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Add the <span className={`${styles.Red}`}>Script Info</span> initially and 
           the <span className={`${styles.Red}`}>Shoot & Post Info</span> where needed as work progresses.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Add the Scene<span className={`${styles.Red}`}> Location</span> using the Location dropdown which contains all Locations
          so far created for the Project.
          </p>
        <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>New</span> Project Locations can be created here by clicking the "Add New Location" tab
          or in the Locations section.</p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Create a Location for every new Script Heading Location.</p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> If a Location has <span className={`${styles.Red}`}>Sublocations</span> create a
          separate new Location for each, e.g., "Jack's Bar - Lounge", "Jack's Bar - Cellar" etc.
          </p>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Heading Info</span> field should be used to denote 
            Intercuts, Montages, Continuous etc.</p>
          <p className={`${styles.SmallInfo} pt-2`}>
          Note: The Storyboard and Script may be added/updated here or in 
          their own pages on the Scene page.
          </p>  
          <hr className={`mt-2 mb-0`}/>
         </div>
      </Col>
    </Row>
    </div>
  )
}

export default Info